import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Bell = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.5 12.065c3.225.66 6.345-4.746 6.345-4.746a6.242 6.242 0 0 1 10.363-.683 6.24 6.24 0 0 1 .455 6.925s-3.12 5.409-.936 7.866L2.512 12.065M15.22 6.93a3.66 3.66 0 0 0-3.17.607m4.487-4.184a1.562 1.562 0 0 1 2.705 1.56M7.559 16.824a2.684 2.684 0 0 0 4.504 2.6"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Bell) as SvgIcon;
export { ForwardRef as ReactComponent };
